import { useState, useEffect } from "react";
import "./styles.css";
import { Link, useParams } from "react-router-dom";
import TechTag from "../techTag";
import GitHubIcon from "../../assets/techStackIcons/gitHubIcon";
import YouTubeIcon from "../../assets/techStackIcons/youTubeIcon";
import HeartIcon from "../../assets/techStackIcons/heartIcon";
import { db } from "../../utils/firebase";
import { doc, updateDoc, getDoc } from "firebase/firestore";

function ProjectDetailsSpace() {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [liked, setLiked] = useState(false);
  const [likes, setLikes] = useState(null);

  useEffect(() => {
    // Check local storage to see if the user has already liked the project
    const likedProjects =
      JSON.parse(localStorage.getItem("likedProjects")) || [];
    if (likedProjects.includes(id)) {
      setLiked(true);
    }

    const fetchProject = async () => {
      const docRef = doc(db, "projects", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setProject({ id: docSnap.id, ...docSnap.data() });
      }
    };

    // Fetch the latest likes value from Firestore
    const fetchLikes = async () => {
      const projectRef = doc(db, "projects", id);
      const projectDoc = await getDoc(projectRef);
      if (projectDoc.exists()) {
        const likes = projectDoc.data().likes;
        setLikes(likes);
      }
    };

    fetchProject();
    fetchLikes();
  }, [id]);

  const handleLikeButtonClick = async () => {
    // Update the local storage and the like count
    const likedProjects =
      JSON.parse(localStorage.getItem("likedProjects")) || [];

    let updatedLikedProjects;
    let newLikeCount;
    if (liked) {
      updatedLikedProjects = likedProjects.filter(
        (projectId) => projectId !== id
      );
      newLikeCount = likes - 1;
    } else {
      updatedLikedProjects = [...likedProjects, id];
      newLikeCount = likes + 1;
    }
    localStorage.setItem("likedProjects", JSON.stringify(updatedLikedProjects));
    setLiked(!liked);
    setLikes(newLikeCount);

    const projectRef = doc(db, "projects", id);
    await updateDoc(projectRef, {
      likes: newLikeCount,
    });
  };

  return project ? (
    <div className="projectDetailsContainer">
      <h1>{project.title}</h1>
      <button
        className={`projectLikeButton ${liked ? "liked" : ""}`}
        onClick={handleLikeButtonClick}
      >
        <HeartIcon style={{ fill: liked ? "red" : "black" }} /> {likes}
      </button>{" "}
      <p className="projectDescription">{project.description.toLowerCase()}</p>
      <h2>PROBLEM</h2>
      <div
        dangerouslySetInnerHTML={{ __html: project.problem.toLowerCase() }}
      />
      <h2>APPROACH</h2>
      <div
        dangerouslySetInnerHTML={{ __html: project.approach.toLowerCase() }}
      />
      <h2>RESULTS</h2>
      <div
        dangerouslySetInnerHTML={{ __html: project.results.toLowerCase() }}
      />
      <h2>LEARNED</h2>
      <div
        dangerouslySetInnerHTML={{ __html: project.learned.toLowerCase() }}
      />
      <h2>how it was made</h2>
      <div className="techStack">
        {project.techStack.map((tech, index) => (
          <TechTag key={index} tech={tech} />
        ))}
      </div>
      <div className="projectLinks">
        {project.youTubeLink === "private" || "" ? null : (
          <Link
            to={project.youTubeLink}
            target="_blank"
            rel="noopener noreferrer"
            className="regularLinks"
            style={{
              border: "1px solid #0000",
              boxShadow: "1px 1px 2px #ff0000, 0px 0px 4px #000",
            }}
            onMouseEnter={(e) => {
              e.target.style.boxShadow =
                "1px 1px 2px #ff0000, 0px 0px 4px #000";
              e.target.style.background = "#ff0000";
              const svgElement = e.target.querySelector("svg");
              if (svgElement) {
                svgElement.style.fill = "#fff";
                svgElement.style.boxShadow = "none";
                svgElement.style.background = "#none";
              }
            }}
            onMouseLeave={(e) => {
              e.target.style.boxShadow =
                "1px 1px 2px #ff0000, 0px 0px 4px #000";
              e.target.style.background = "none";
              const svgElement = e.target.querySelector("svg");
              if (svgElement) {
                svgElement.style.fill = "#ff0000";
                svgElement.style.boxShadow = "none";
                svgElement.style.background = "none";
              }
            }}
          >
            {YouTubeIcon()}
          </Link>
        )}

        {project.gitHubLink === "private" || "" ? null : (
          <Link
            to={project.gitHubLink}
            target="_blank"
            rel="noopener noreferrer"
            className="regularLinks"
            style={{
              border: "1px solid #0000",
              boxShadow: "1px 1px 2px #000, 0px 0px 4px #000",
            }}
            onMouseEnter={(e) => {
              e.target.style.boxShadow = "1px 1px 2px #000, 0px 0px 4px #000";
              e.target.style.background = "#000";
              const svgElement = e.target.querySelector("svg");
              if (svgElement) {
                svgElement.style.fill = "#fff";
              }
            }}
            onMouseLeave={(e) => {
              e.target.style.boxShadow = "1px 1px 2px #000, 0px 0px 4px #000";
              e.target.style.background = "none";
              const svgElement = e.target.querySelector("svg");
              if (svgElement) {
                svgElement.style.fill = "#000";
              }
            }}
          >
            {GitHubIcon()}
          </Link>
        )}
      </div>
      <Link className="projectDetailsExitButton" to={"/projects"}>
        go back
      </Link>
    </div>
  ) : null;
}

export default ProjectDetailsSpace;
